// Copyright (c) Bentley Systems
export const HTTP_HEADERS = {
  CONTENT_TYPE: "Content-Type",
  AUTHORIZATION: "Authorization",
  RUN_ID: "RunId",
  ITWIN_ID: "Itwin-ID",
} as const;

export const CONTENT_TYPES = {
  JSON: "application/json",
} as const;
